<template>
  <v-container>
    <current-user-can permission="editLookups">
      <v-card>
        <v-card-text>
          <v-data-table
            :items="selectedLookupValues"
            :headers="columnHeaders"
            @click:row="editValue"
            :loading="loading"
            dense
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lookups</v-toolbar-title>
                <v-divider inset vertical class="mx-4" />
                <v-autocomplete
                  v-model="selectedLookup"
                  :items="lookupOptions"
                  placeholder="Select Lookup..."
                  single-lineclass="ml-4"
                  auto-select-first
                  autofocus
                />
                <v-spacer></v-spacer>
                <v-btn @click="addNewItem" v-if="selectedLookup">
                  Add {{ selectedLookup }}...
                </v-btn>
              </v-toolbar>
            </template>

            <template v-slot:item.inactive="{ item }">
              <v-simple-checkbox
                disabled
                :value="item.inactive"
              ></v-simple-checkbox>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </current-user-can>
    <v-dialog card max-width="30em" v-model="displayEditDialog">
      <v-card>
        <v-form @submit.prevent="saveValue">
          <v-card-title>
            Edit <em>{{ selectedLookup }}</em> option:
          </v-card-title>
          <v-card-text>
            <v-text-field
              autofocus
              v-model="selectedItem.value"
              label="name"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-alert dense small color="error" v-if="saveError">{{
              saveError.message
            }}</v-alert>
            <v-spacer></v-spacer>
            <v-btn :loading="saving" type="submit" color="primary">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "editLookups",
  computed: {
    lookups() {
      return this.$store.getters.lookups || {};
    },
    lookupOptions() {
      let keys = [];
      /* eslint-disable-next-line */
      for (const lu in this.lookups) {
        let values = this.lookups[lu];
        if (values[0] && values[0]["@type"] !== "Lookupvalue") {
          continue;
        } else {
          keys.push(lu);
        }
      }
      return keys;
    },
    selectedLookupValues() {
      return this.lookups[this.selectedLookup];
    }
  },
  data() {
    return {
      showLookups: {},
      selectedLookup: "",
      displayEditDialog: false,
      selectedItem: {},
      loading: false,
      saving: false,
      saveError: null,
      columnHeaders: [
        { text: "ID", value: "valueid", width: "5em", sortable: false },
        { text: "Value", value: "value" }
        // { text: "Inactive", value: "inactive" }
      ]
    };
  },
  methods: {
    editValue(item) {
      this.selectedItem = { ...item };
      this.displayEditDialog = true;
    },
    addNewItem() {
      this.saveError = null;
      this.selectedItem = {
        name: "",
        lookupid: this.selectedLookupValues[0].lookupid,
        valueid: null,
        inactive: false
      };
      this.displayEditDialog = true;
    },
    async saveValue() {
      this.saveError = null;
      const item = this.selectedItem;
      console.log("saving lookupvalue", item);
      try {
        this.saving = true;
        if (item.valueid) {
          await this.$http.post(`/lookupvalues/update`, item, {
            params: {
              where: { lookupid: item.lookupid, valueid: item.valueid }
            }
          });
        } else {
          await this.$http.post(`/lookupvalues/`, item);
        }
        this.loading = true;
        await this.$store.dispatch("LOAD_CONFIG");
        this.displayEditDialog = false;
      } catch (e) {
        this.saveError = e;
      } finally {
        this.saving = false;
        this.loading = false;
      }
    }
  },
  watch: {
    lookupOptions: {
      handler(newVal) {
        if (!this.selectedLookup) {
          this.selectedLookup = newVal[0];
        }
      },
      immediate: true
    }
  }
};
</script>
